module.exports = __webpack_public_path__ + "media/images/products/products/h6-889a5578c2fed300d5b311294a806f64.jpg";